export default {
  namespaced: true,
  state: {
    applying: "",
    cashReceiptCategory: "INCOME_DEDUCTION",
    cashReceiptRegType: "",
    regTypeNum: "",
  },
  mutations: {
    reset(state) {
      state.applying = "";
      state.cashReceiptCategory = "INCOME_DEDUCTION";
      state.cashReceiptRegType = "";
      state.regTypeNum = "";
    },
    updateApplying(state, value = "") {
      state.applying = value;
    },
    updateRegType(state, value = "") {
      state.cashReceiptRegType = value;
    },
    updateRegTypeNum(state, value = "") {
      state.regTypeNum = value;
    }
  },
  getters: {
    getReceiptInfo(state) {
      return {
        applying: state.applying,
        cashReceiptCategory: state.cashReceiptCategory,
        cashReceiptRegType: state.cashReceiptRegType,
        regTypeNum: state.regTypeNum
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/receipt.js